import {
  useBilling,
  useDashboard,
  useTeam,
  useTeamRole,
} from '@vrplatform/data';
import { day, fromNow } from '@vrplatform/utils';
import { Box, Collapse, Progress, Text, rem } from '@mantine/core';
import { useMemo, useState } from 'react';
import { UpgradeSubscriptionButton } from '../../../components';
import { useNavbarExpanded } from '../../../hooks';

export function useNavbarTrialCard() {
  const {
    subscription: {
      status: billingStatus,
      cancelledAt: subscriptionCancelledAt,
      trialUntil: subscriptionTrialUntil,
      paymentMethodType,
    },
  } = useBilling();
  const [dashboard] = useDashboard();
  const { isTeamAdmin } = useTeamRole();
  const [{ isGL: GL }] = useTeam();

  return useMemo(() => {
    const showTrialCard =
      GL &&
      dashboard !== 'owner' &&
      billingStatus === 'active' &&
      !subscriptionCancelledAt && // hasnt cancelled
      subscriptionTrialUntil &&
      day(subscriptionTrialUntil).isValid() &&
      day(subscriptionTrialUntil).isAfter(day(), 'day');

    const showUpgradeButton =
      showTrialCard && !paymentMethodType && isTeamAdmin; // hasnt upgraded yet

    return {
      showTrialCard,
      showUpgradeButton,
      trialUntil: subscriptionTrialUntil,
    };
  }, [
    GL,
    dashboard,
    billingStatus,
    subscriptionCancelledAt,
    paymentMethodType,
    subscriptionTrialUntil,
    isTeamAdmin,
  ]);
}

export const NavbarTrialCard = () => {
  const { showTrialCard, trialUntil } = useNavbarTrialCard();
  const [isVisible, setIsVisible] = useState(true);

  const { isDesktopExpanded } = useNavbarExpanded();
  const [{ createdAt }] = useTeam();

  if (showTrialCard) {
    const daysFromNow = day(trialUntil).diff(day(), 'days');
    const totalDays = day(trialUntil).diff(createdAt, 'days');
    const remaining = ((totalDays - daysFromNow) / totalDays) * 100;

    return (
      <Collapse in={isVisible}>
        <Box
          py={rem(10)}
          px={rem(8)}
          title="Trial"
          sx={(theme) => ({
            backgroundColor: '#ffffff10',
            borderRadius: theme.radius.md,
          })}
        >
          {isDesktopExpanded && (
            <Text size="sm" c="white" fw={500} mb={rem(5)}>
              Your trial ends {fromNow(trialUntil)}
            </Text>
          )}
          <Progress
            value={remaining || 1}
            color="yellow"
            size="sm"
            mb={isDesktopExpanded ? 'sm' : undefined}
            sx={{
              backgroundColor: '#ffffff30',
            }}
          />
          {isDesktopExpanded && (
            <UpgradeSubscriptionButton
              onSuccess={() => {
                setIsVisible(false);
              }}
            />
          )}
        </Box>
      </Collapse>
    );
  }

  return null;
};
